GameView    = require "views/base/game"
{ DraggyView } = require("views/components/draggy")
SmoothLine = require("lib/draw/smooth-line")
Preloader  = require("lib/preload")
{ dpi }    = require("lib/device")

class ConnectView extends GameView
  template: require("./template")
  fitTextOnResize: false
  fitTextOnRender: false

  events: ->
    "iostap .btn-done": "endGame"

  serialize: ->
    data = super()

    data.pairs = 
      _.chain(@options.metadata.questions)
        .map(({ question, answers }) ->

          # questions use id outside of a question pool and questionId inside a question pool
          # answers use id outside of a question pool and answerId inside a question pool
          question.id = question.id or question.questionId
          answers = _.each answers, (answer) ->
            answer.id = answer.id or answer.answerId

          left: question, right: _.find(answers, 'correct'))
        .filter(({ left, right }) -> left and right)
        .value()

    # Render with array of correct answer IDs for the case where answers
    # have the same answer text content so the user may use more than one
    # answer 'box' to correctly answer the question
    answerIdsByContentDict = _.chain(@options.metadata.questions)
      .map(({answers}) -> answers)
      .flatten()
      .groupBy((i) -> i.content)
      .mapObject((answers) -> _.pluck(answers, 'id'))
      .value()

    data.leftItems = _.chain(data.pairs)
      .pluck('left')
      .map(({ content, type, id }, index) ->
        { 
          content: content ? "",
          contentType: type,
          index,
          id }
      )
      .shuffle()
      .value()
    data.rightItems = _.chain(data.pairs)
      .pluck('right')
      .map(({ content, type }, index) ->
        {
          content: content or "",
          contentType: type,
          index,
          ids: answerIdsByContentDict[content]
        }
      )
      .shuffle()
      .value()

    data

  show: ->
    super
    @setEl @findAll(".connect-box"), "boxes"

    @draggy = new DraggyView
      el: @findOne("canvas")
      isParent: true

    @context = @draggy.el.getContext?("2d") or {}

    @listenTo @draggy, "drag", @onDrag
    @listenTo @draggy, "drop", @onDrop
    @listenTo this, "resize", @onResize

    @onResize()

    @pairs = []

    @context.clearRect?(0, 0, @draggy.el.width, @draggy.el.height)
    el.classList.remove("active", "complete") for el in @getEl("boxes")

    @enterGame()

  onRefresh: ->
    super

    for el in @getEl("boxes") or []
      el.style.height = ""
      el.offsetHeight

  onResize: (done) ->
    @findOne(".content-fit")?.style.fontSize = ""
    el.style.height = "" for el in @getEl("boxes")

    unless @currentState?.refresh
      @el.classList.remove("active")

    images = @findAll("img")
    Preloader.load _.pluck(images, "src"), (errors = []) =>
      fontSize = parseInt window.getComputedStyle(@el).fontSize
      height = _.reduce @getEl("boxes"), (m, el) ->
        if el.offsetHeight > m then el.offsetHeight else m
      , 0

      for el in @getEl("boxes")
        el.style.height = height / fontSize + "em"
        el.classList.remove("active")

      if el = @draggy?.el
        el.width  = @el.firstChild.offsetWidth * dpi
        el.height = @el.firstChild.offsetHeight * dpi

      @fitText =>
        window.setTimeout (=> @el.classList.add("active")), 300

  onDrag: (draggy, isInitial) ->
    window.clearTimeout @timeout
    { left, top } = @getBounds(@el.firstChild)

    if isInitial
      @line?.animation?.cancel()
      @context.lineCap = "round"
      @context.globalAlpha = 1
      @line = new SmoothLine([], window.getComputedStyle(@el).color, 4 * dpi)
      @activeBox = null

      for el, i in @getEl("boxes")
        bounds   = @getBounds el, { x: -left, y: -top }
        isWithin = draggy.isWithin(bounds, 0)
        el.classList.toggle("active", isWithin)

        if isWithin
          el.classList.remove("complete")
          @activeBox = el
          @removeActivePairs(el)

    else if @activeBox
      for el in @getEl("boxes")
        if el isnt @activeBox and
           el.dataset.type isnt @activeBox.dataset.type

          bounds   = @getBounds el, { x: -left, y: -top }
          isWithin = draggy.isWithin(bounds, 0)
          el.classList.toggle("active", isWithin)

    @addPoint(draggy)

  onDrop: ->
    active = (b for b in @getEl("boxes") when b.classList.contains("active"))

    if active.length is 2
      for el in active
        el.classList.add("complete")
        @removeActivePairs(el)

      @pairs.push
        active: active
        line: new SmoothLine(@line.getPoints(), "rgba(0,0,0,.25)", 8 * dpi)

    for el in active
      el.classList.remove("active")

    @line.erase @context, =>
      @context.clearRect(0, 0, @draggy.el.width, @draggy.el.height)
      @context.globalAlpha = 1
      line.draw(@context) for { line } in @pairs

    if @pairs.length is @options.data.pairs.length
      @setState("touched")
    else
      @setState("prompt")

  removeActivePairs: (el) ->
    for pair in @pairs
      if _.include pair.active, el
        @pairs = _.without @pairs, pair
        for active in pair.active when active isnt el
          active.classList.remove("complete")

  addPoint: ({x, y}) ->
    @line.add x: x * dpi, y: y * dpi
    @drawLines()

  drawLines: ->
    @draggy.el.offsetHeight
    @context.clearRect(0, 0, @draggy.el.width, @draggy.el.height)

    line.draw(@context) for { line } in @pairs
    @line.draw(@context)

  showAnswer: ->
    for { active: [left, right] } in @pairs
      isIncorrect = not @isMatch left, right
      left.classList.toggle("incorrect", isIncorrect)
      right.classList.toggle("incorrect", isIncorrect)

  isCorrect: ->
    correct = _.filter @pairs, ({ active: [left, right] }) =>
      @isMatch left, right

    correct.length is @options.data.pairs.length

  getQuestionAnswerFromInput: (questions) -> (els) ->
    questionsById = _.indexBy(questions, ({ question }) -> question.id)
    questionId    = _.find(els,((e) -> e.dataset.questionId)).dataset?.questionId
    answerIds     = JSON.parse(_.find(els,((e) -> e.dataset.answerIds)).dataset.answerIds)
    { question, answers }  = questionsById[questionId]

    # Find the correct answer ID from the answer IDs associated with the question
    # for the case where multiple answers have the same text content
    answer = _.find answers, ({ id }) -> id in answerIds

    { question, answer }

  isMatch: (left, right) ->
    { answer } = @getQuestionAnswerFromInput(@options.metadata?.questions)([left, right])
    answer?.correct

  answerDetails: ->
    questions = @options.metadata?.questions or []
    return [] unless questions.length > 0

    getQuestionAnswerFromInput = @getQuestionAnswerFromInput(questions)

    return _.chain(@pairs)
      .map(({ active }) => # Find question/answer id from the active element pairs on the page
        getQuestionAnswerFromInput active
      )
      # Filter out elements without a question/answer ID
      .filter(({ question, answer }) -> question and answer)
      .value()

  endGame: ->
    super

    @submit()

module.exports = ConnectView
